// What a game page shows, as its reader toggled it: which update kinds are
// marked on the chart and listed under it, whether sales are shaded, which
// regions' evenings are, and what a hovered toggle previews. The remembered
// ones are prefs.ts's RememberedSets; chart-draw.ts draws by them and
// render-game.ts wires up their toggles.

import { EVENINGS } from "../../shared/evenings.ts";
import { RememberedSet } from "./prefs.ts";
import { DEFAULT_UPDATE_KINDS, UPDATE_LABELS } from "./updates.ts";

// Which update kinds are marked on the chart, toggled under it, and which
// are listed under "Recent updates", toggled there: apart, each remembered
// per browser.
export const shownKinds = new RememberedSet("updateKinds", UPDATE_LABELS, DEFAULT_UPDATE_KINDS);
export const listedKinds = new RememberedSet("listedUpdateKinds", UPDATE_LABELS, DEFAULT_UPDATE_KINDS);

// Whether sales are shaded on the chart ("sales" in it), toggled under it
// and remembered per browser; on until a reader turns them off.
export const shownSales = new RememberedSet("showSales", { sales: true }, ["sales"]);

// Which regions' evenings are shaded on the hourly chart: those toggled on
// under it, remembered per browser (none until a reader picks some), and
// those the play-time insight turned on, for this page only (pageEvenings,
// cleared by every navigation).
export const shownEvenings = new RememberedSet("eveningRegions", EVENINGS, []);
export const pageEvenings = new Set<string>();

// Whether a region's evenings are shaded, by a toggle or by the insight.
export const isShaded = (region: string): boolean => shownEvenings.has(region) || pageEvenings.has(region);

// An update kind whose toggle is off but hovered: the chart shows its
// markers, faded, a preview of turning it on (see render-game.ts). null when
// no off toggle is hovered.
export let previewKind: string | null = null;

export const setPreviewKind = (kind: string | null): void => {
  previewKind = kind;
};

// The regions whose evenings are previewed while an off evening toggle, or
// the insight while it's off, is hovered.
export let previewEvenings: string[] = [];

export const setPreviewEvenings = (regions: string[]): void => {
  previewEvenings = regions;
};
